import { BaseApi } from './base.api.js';

export class UserApi extends BaseApi {
    constructor(client) {
        super(client, '/user');
    }

    async getLicenseStats() {
        return this.client.get(this.basePath + '/license-stats');
    }

    /**
     * @param {Record<string, unknown>} params query params aligned with getAll + maxRows
     * @returns {Promise<Blob>}
     */
    async exportCsv(params = {}) {
        const response = await this.client.get(`${this.basePath}/export`, {
            params: { ...params, maxRows: params.maxRows || 2000 },
            responseType: 'blob',
            headers: { Accept: 'text/csv' }
        });
        return response.data;
    }

    async invite(data) {
        const response = await this.client.post(`${this.basePath}/invite`, data);
        return response.data;
    }

    async resendInvite(id) {
        const response = await this.client.post(`${this.basePath}/${id}/resend-invite`);
        return response.data;
    }

    async batchPatch(data) {
        const response = await this.client.post(`${this.basePath}/batch-patch`, data);
        return response.data;
    }

    /**
     * Get the current user's unit-role assignments.
     * @param {string} userId
     */
    async getUnitRoleAssignments(userId) {
        const response = await this.client.get(`${this.basePath}/${userId}/unit-roles`);
        return response.data;
    }
}
